import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import styles from './home.module.css';

import logoWeibo from './assets/desktop_home_ic_weibo@2x.png';
import logoFB from './assets/desktop_home_ic_fb@2x.png';
@inject('app')
@observer
class Home extends Component {
  componentDidMount() {
    const { app } = this.props
    app.setBreadcrumbs(['live'])
  }

  render() {
    const { app } = this.props;
    const { langs } = app;

    const tools = [
      {
        href: '/live/weibo',
        logo: logoWeibo,
        height: '45px',
        bg: 'rgb(230, 34, 57)'
      },
      {
        href: '/live/facebook',
        logo: logoFB,
        height: '40px',
        bg: 'rgb(87, 128, 217)'
      },
    ];
    return (
      <div>
        <h2 className={styles.title}>{langs['live_home_t1']}</h2>
        <div className={styles.tool_list}>
          {
            tools.map((tool, index) => {
              return (
                <Link to={tool.href} key={index} className={styles.tool} style={{
                  backgroundColor: tool.bg
                }}>
                  <img src={tool.logo} style={{height: tool.height}} />
                </Link>
              )
            })
          }
        </div>
        
        <p className={styles.bottom} dangerouslySetInnerHTML={{ __html: langs['live_home_t2'] }}></p>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/live/home.js